import { gql } from '@apollo/client';

const StoriesQueryHi = gql
`query MyQuery {
  nodeStoriesOfChangeAndTestimonia(first: 10, langcode: "hi") {
    nodes {
      title
      path
      created {
        time
      }
      __typename
      body {
        value
      }
      imageAbout {
        url
        alt
      }
      commonBanner {
        ... on MediaCommonBanner {
          id
          name
          mediaImage2 {
            url
            alt
          }
        }
      }
    }
  }
}
`;

export default StoriesQueryHi;